enum Project {
  SET_PROJECT_INITIALIZE = 'SET_PROJECT_INITIALIZE',
  SET_PROJECT_LIST = 'SET_PROJECT_LIST',
  SET_PROJECT_INFO = 'SET_PROJECT_INFO'
}

export default Project;
